import api from "../../config/client.axios.api";

export const getMachineOfStoreApiRequest = async (storeId: string) => {
  const response = await api.get(`/machine/find-by-store/${storeId}`);
  return response.data;
};
